
  import Themeable from 'vuetify/lib/mixins/themeable'
  import HasScope from '@/components/Mixins/HasScope'
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import { Item as ItemInterface } from '@/views/interfaces/vuetify/item.interface'

  @Component({
    mixins: [
      Themeable,
      HasScope,
    ],
  })
  export default class Item extends Vue {
    [x: string]: any;

    @Prop({ type: String, default: '' }) private readonly scope!: string
    @Prop({
      type: Object, default: () => ({
        href: undefined,
        icon: undefined,
        subtitle: undefined,
        title: undefined,
        to: undefined,
      }),
    }) private readonly item!: ItemInterface
    @Prop({ type: Boolean, default: false }) private readonly text!: boolean
    @Prop({ type: String, default: '' }) private readonly icon!: string
    @Prop({ type: String, default: 'small' }) private readonly iconSize!: string

    get computedText(): string {
      if (!this.item.title) {
        return ''
      }

      let text = ''

      this.item.title.split(' ').forEach((val: string) => {
        text += val.substring(0, 1)
      })

      return text
    }

    get href(): string | undefined {
      return this.item.href || (!this.item.to ? '#' : undefined)
    }

    get route(): string {
      if (this.item.toFixed) {
        return this.item.toFixed
      } else if (this.item.to) {
        return this.item.to
      }

      return ''
    }

    /**
     * active-class is applied whenever vue-router considers the link active (prefix match).
     * Only use the visible active class on an exact path match so /websites/ does not
     * stay highlighted on /websites/groups. Related child routes use ItemGroup.getActiveTab.
     * Always return a non-empty string so Vuetify does not fall back to v-list-item--active.
     */
    get activeClass(): string {
      const path = this.item.toFixed !== undefined ? this.item.toFixed : this.item.to
      if (path !== undefined && this.pathsMatch(this.$route.path, path)) {
        return 'drawer-item--active'
      }

      return 'drawer-item--idle'
    }

    private pathsMatch(current: string, target: string): boolean {
      const normalize = (p: string): string => p.replace(/\/+$/, '') || '/'
      return normalize(current) === normalize(target)
    }
  }
